import React from 'react';
import './footer.css';

function Footer() {
  return (
    <div style={{ width: '100%' }} className='mt-auto text-center '>
      <hr></hr>
      <p className='text-center copy-right'>© {new Date().getFullYear()} Copyright by spemai. All rights reserved.</p>
    </div>
  );
}

export default Footer;
